import { z, ZodType } from 'zod';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';

export type AccountTransaction = {
	id: string;
	date: string;
	from: EntityWithName | null;
	to: EntityWithName | null;
	currency: string;
	amount: number;
	type: string;
	balanceBefore: number;
	balanceAfter: number;
};

export const accountTransactionSchema: ZodType<AccountTransaction> = z.object({
	id: z.string(),
	date: z.string(),
	from: entityWithNameSchema.nullable(),
	to: entityWithNameSchema.nullable(),
	currency: z.string(),
	amount: z.number(),
	type: z.string(),
	balanceBefore: z.number(),
	balanceAfter: z.number(),
});
